<template>
  <SecondaryModal
    v-if="chat"
    name="edit-group"
    :title="$t('chat.editGroup')"
    @before-open="beforeOpen"
  >
    <div :class="$style.container">
      <BaseInput
        label="Group name"
        v-model="name"
        :invalid="$v.name.$error"
        :error="nameError"
      />
      <BaseInput
        :label="$t('chat.description')"
        multiline rows="3"
        v-model="description"
        :invalid="$v.description.$error"
        :error="descriptionError"
      />
    </div>
    <template v-slot:footer>
      <BaseButton oval secondary @click="$modal.hide('edit-group')">{{ $t('buttonCancel') }}</BaseButton>
      <BaseButton oval :loading="loading" @click="submit">{{ $t('buttonSave') }}</BaseButton>
    </template>
  </SecondaryModal>
</template>

<script>
import SecondaryModal from '@/components/modals/SecondaryModal'
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import { NAME_MAX_LENGTH, DESCRIPTION_MAX_LENGTH } from '@/models/Chat'

export default {
  name: 'edit-group-popup',
  components: {
    SecondaryModal
  },
  data () {
    return {
      name: '',
      description: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      chat: 'entities/chats/activeChat'
    }),
    nameError () {
      if (!this.$v.name.maxLength) {
        return `${this.$t('errorMaxLength_begin')} ${NAME_MAX_LENGTH} ${this.$t('errorLength_end')}`
      }
      return this.$t('errorEmptyField')
    },
    descriptionError () {
      return `${this.$t('errorMaxLength_begin')} ${DESCRIPTION_MAX_LENGTH} ${this.$t('errorLength_end')}`
    }
  },
  validations: {
    name: {
      required,
      maxLength: maxLength(NAME_MAX_LENGTH)
    },
    description: {
      maxLength: maxLength(DESCRIPTION_MAX_LENGTH)
    }
  },
  methods: {
    beforeOpen () {
      this.name = this.chat ? this.chat.name : ''
      this.description = this.chat ? this.chat.description : ''
      this.loading = false
    },
    ...mapActions({
      updateChat: 'entities/chats/edit'
    }),
    async submit () {
      this.$v.$touch()
      if (this.loading || this.$v.$invalid) return
      this.loading = true
      try {
        await this.updateChat({
          id: this.chat.id,
          name: this.name,
          description: this.description
        })
      } catch (e) {
        // const errorObj = e.response.data
        // const error = errorObj.chat ? errorObj.chat[0] : errorObj
        this.$modal.show('error', { error: e })
      } finally {
        this.$modal.hide('edit-group')
        this.loading = false
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  text-align: left;
}
</style>
